import { forwardRef, type HTMLAttributes } from "react";

import styles from "./badge.module.css";
import { cx } from "./cx";

type Variant = "neutral" | "success" | "warning" | "error" | "info";
type Size = "sm" | "md";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
  size?: Size;
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = "neutral", size = "md", ...props }, ref) => (
    <span
      ref={ref}
      className={cx(styles.badge, styles[variant], styles[size], className)}
      {...props}
    />
  ),
);

Badge.displayName = "Badge";
